import API from '@/api'
import { ProgramAPI, CropAPI } from '@/api'

export default {
  namespaced: true,
  state: {
    soilTests: [],
    tissueTests: [],
    waterTests: [],
    mediaAnalyzes: [],

    irrigation: {
      data: {
        general: {
          water: 0,
          duration: 0
        },
        perStage: {}
      },
      type: 'general',
    },

    is_irrigation_new: false,
  },
  mutations: {

    setSoilTests (state, data) {
      state.soilTests = data;
    },

    setMediaAnalysis (state, data) {
      state.mediaAnalyzes = data;
    },

    setTissueTests (state, data) {
      state.tissueTests = data;
    },

    setWaterTests (state, data) {
      state.waterTests = data;
    },

    setIrrigation (state, data) {
      var stages = data.stages;
      data = data.data;

      let totalDuration = 0;
      for(let stage of stages) {
        totalDuration += +stage.data[0].value;
        state.irrigation.data.perStage['stage_' + stage.id] = {
          id: stage.id,
          name: stage.name,
          water: 0,
          duration: stage.data[0].value
        };
      }

      state.irrigation.data.general.duration = totalDuration;
      if (data != false) {
        if(data[0].stageId == 0) {
          state.irrigation.data.general.water = data[0].waterPerStage;
        } else {
          state.irrigation.type = 'per-stage';
          for(let stage in data) {
            state.irrigation.data.perStage['stage_' + data[stage].stageId].water = data[stage].waterPerStage;
          }
        }
      } else {
        state.irrigation.data.general.water = 0;
      }
    }
  },
  actions: {

    async onUpdate({ dispatch, getters }) {

      const prog = getters.program;

      const is_water_filled = prog.waterTest ? !!prog.waterTestId : true;
      const is_tissue_filled = prog.tissueTest ? !!prog.tissueTestId : true;
      const is_soil_filled = prog.soilTest ? !!prog.soilTestId : true;

      if(
        is_water_filled &&
        is_tissue_filled &&
        is_soil_filled
      ) {
        await dispatch('program/steps/setCurrentStep', 'tests', { root: true });
        // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'tests', { root: true });
      }

      dispatch('program/fertigation/destroyState', '', { root: true });
      dispatch('program/base-dressing/destroyState', '', { root: true });
      dispatch('program/fertilizers/destroyState', '', { root: true });
    },

    destroyState({ state, commit }) {
      state.soilTests = [];
      state.tissueTests = [];
      state.waterTests = [];
      state.mediaAnalyzes = [];
      state.irrigation = {
        data: {
          general: {
            water: 0,
            duration: 0
          },
          perStage: {}
        },
        type: 'general',
      };
    },

    async removeTest({ state, commit, getters, dispatch }, type) {
      await API.program.removeTestFromProgram(type, getters.program.id);

      if (type == 'soil') {
        commit('program/setFieldValue', {
          soilTestId: null,
        }, { root: true });
      } else if (type == 'water') {
        commit('program/setFieldValue', {
          waterTestId: null,
        }, { root: true });
      } else if (type == 'tissue') {
        commit('program/setFieldValue', {
          tissueTestId: null,
        }, { root: true });
      }
      else if (type == 'media') {
        commit('program/setFieldValue', {
          mediaAnalysisId: null,
        }, { root: true });
      }

      await dispatch('onUpdate');
    },

    setSoilTests({ state, commit, getters }) {
      return API.program.getSoilTestsByField(getters.program.fieldId).then(res => {
        commit('setSoilTests', res.data.data);
      });
    },

    async addSoilTest({ state, commit, dispatch, getters }, id) {
      await API.program.addSoilTestToProgram(id, getters.program.id)
      commit('program/setFieldValue', {
        soilTestId: id,
      }, { root: true });
      await dispatch('onUpdate');
    },

    // TODO поменять названия рутов

    setMediaAnalyzes({ state, commit, getters }) {
      return API.program.getMediaAnalyzesByField(getters.program.fieldId).then(res => {
        commit('setMediaAnalysis', res.data.data);
      });
    },

    async addMediaAnalysis({ state, commit, dispatch, getters }, id) {
      await API.program.addMediaAnalysisToProgram(id, getters.program.id)
      commit('program/setFieldValue', {
        mediaAnalysisId: id,
      }, { root: true });
      await dispatch('onUpdate');
    },

    //////

    setTissueTests({ state, commit, getters }) {
      return API.program.getTissueTestsByField(getters.program.fieldId).then(res => {
        commit('setTissueTests', res.data.data);
      });
    },

    async addTissueTest({ state, commit, dispatch, getters }, id) {
      await API.program.addTissueTestToProgram(id, getters.program.id);
      commit('program/setFieldValue', {
        tissueTestId: id,
      }, { root: true });
      await dispatch('onUpdate');
    },

    setWaterTests({ state, commit, getters }) {
      return API.program.getWaterTestsByField(getters.program.fieldId).then(res => {
        commit('setWaterTests', res.data.data);
      });
    },

    async addWaterTest({ state, commit, dispatch, getters }, id) {
      await API.program.addWaterTestToProgram(id, getters.program.id);
      commit('program/setFieldValue', {
        waterTestId: id,
      }, { root: true });
      await dispatch('onUpdate');
    },

    async getIrrigation({ state ,rootState, commit, dispatch, rootGetters, getters }) {
      const units = rootState.user.data.units;
      const stages = await CropAPI.getCropStages(getters.program.cropYieldGoalId)
        .then(res => res.data.data);

      const data = await ProgramAPI.getIrrigationByProgramId(getters.program.id)
        .then(res => res.data.data)
        .then(data => data.length ? data : false)
        if(units.toLowerCase() === 'us') {
          data.forEach(e => {
            e.waterPerStage = rootGetters['unit/unConvert']('m3', e.waterPerStage).toFixed(2)
          })
        }
      commit('setIrrigation', {
        stages,
        data
      });
      console.log(data)
      if(!data.length) {
        dispatch('saveIrrigation');
      }
    },

    async saveIrrigation({ state, rootState, commit, dispatch, getters, rootGetters }) {
      const units = rootState.user.data.units;
      let req = {
        irregationType: '',
        amounts: [],
        waterAnalysisId: getters.program.waterTestId,
        programId: getters.program.id,
      };

      const data = {
        irrigation: state.irrigation.data,
        irrigationType: state.irrigation.type,
      };

      if(data.irrigationType == 'general') {
        req.irregationType = 'general';
        req.amounts = {
          water: units.toLowerCase() == 'us' ? rootGetters['unit/convert']('m3', data.irrigation.general.water) : data.irrigation.general.water,
          stageId: 0,
          stageDuration: data.irrigation.general.duration,
        }
      } else {
        req.irregationType = 'per-stage';
        req.amounts = [];
        for (var stage in data.irrigation.perStage) {
          req.amounts.push({
            water: units.toLowerCase() == 'us' ? rootGetters['unit/convert']('m3', data.irrigation.perStage[stage].water) : data.irrigation.perStage[stage].water ,
            stageId: data.irrigation.perStage[stage].id,
            stageDuration: data.irrigation.perStage[stage].duration,
          });
        }
      }

      await API.program.addIrrigationToWaterTest(req).then(() => {
        dispatch('onUpdate');
      });
    }

  },
  getters: {
    soilTests (state) {
      return state.soilTests;
    },

    program(state, getters, rootState, rootGetters) {
      return rootGetters['program/data'];
    },

    soilTestId (state, getters, rootState, rootGetters) {
      return getters.program.soilTestId;
    },

    tissueTests (state) {
      return state.tissueTests;
    },

    tissueTestId (state, getters, rootState, rootGetters) {
      return getters.program.tissueTestId;
    },

    waterTests (state) {
      return state.waterTests;
    },

    waterTestId (state, getters, rootState, rootGetters) {
      return getters.program.waterTestId;
    },

    mediaAnalyzes (state) {
      return state.mediaAnalyzes;
    },

    mediaAnalysisId (state, getters, rootState, rootGetters) {
      return getters.program.mediaAnalysisId;
    },

    irrigation (state) {
      return state.irrigation;
    },

    tests(state, getters, rootState, rootGetters) {
      const res = [];
      const program = getters.program;
      if (program.soilTest == 1) {
        res.push('soil')
      }
      if (program.waterTest == 1) {
        res.push('water')
      }
      if (program.tissueTest == 1) {
        res.push('tissue')
      }
      if (program.mediaAnalysis == 1) {
        res.push('media')
      }
      return res;
    },
  }
};
